import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { EthicsComponent } from './components/ethics/ethics.component';
import { SearchComponent } from './pages/search/search.component';
import { SearchDetailedScreenComponent } from './pages/search-detailed-screen/search-detailed-screen.component';
import { PlatformComponent } from './pages/platform/platform.component';
import { TechnicalRoutesComponent } from './components/platform-tabs/technical-routes/technical-routes.component';
import { CipacComponent } from './components/platform-tabs/cipac/cipac.component';
import { GapdComponent } from './components/platform-tabs/gapd/gapd.component';
import { ProductInformationComponent } from './components/platform-tabs/product-information/product-information.component';
import { MrlComponent } from './components/platform-tabs/mrl/mrl.component';
import { DetailComponent } from './components/detail/detail.component';
import { ImpPatentComponent } from './components/platform-tabs/imp-patent/imp-patent.component';
import { ImpuritiesComponent } from './components/platform-tabs/impurities/impurities.component';
import { NonPatentLandscapeComponent } from './components/platform-tabs/non-patent-landscape/non-patent-landscape.component';
import { LitigationComponent } from './components/platform-tabs/litigation/litigation.component';
import { ScientificDocsComponent } from './components/platform-tabs/scientific-docs/scientific-docs.component';
import { SpcComponent } from './components/platform-tabs/spc/spc.component';
import { QuikPatentComponent } from './components/platform-tabs/quik-patent/quik-patent.component';
import { IpdComponent } from './components/platform-tabs/ipd/ipd.component';
import { PatentDetailsComponent } from './pages/patent-details/patent-details.component';
import { PatentSubcategoryComponent } from './pages/patent-subcategory/patent-subcategory.component';
import { PatentCategoriesComponent } from './pages/patent-categories/patent-categories.component';
import { PatentComponent } from './pages/patent/patent.component';
import { NewsCategoriesComponent } from './pages/news-categories/news-categories.component';
import { SupportComponent } from './components/support/support.component';



export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'ethics', component: EthicsComponent },
  { path: 'search', component: SearchComponent }, 

  // { path: 'search-test', component: TestComponent },

//   { path: 'product-information', component: ProductInformationComponent },


  {
    path: '',
    children: [
      { path: '', pathMatch: 'full', component: HomeComponent },
      { path: 'discovery', pathMatch: 'full', component: PatentComponent },
      {
        path: 'discovery-category/:catid',
        pathMatch: 'full',
        component: PatentCategoriesComponent,
      },
      {
        path: 'SubCategory/:id',
        pathMatch: 'full',
        component: PatentSubcategoryComponent,
      },
      {
        path: 'discovery-updates/:id',
        pathMatch: 'full',
        component: PatentDetailsComponent,
      },
      {
        path: 'search/:keyword',
        pathMatch: 'full',
        component: SearchComponent,
      },
      {
        path: 'news_categories',
        pathMatch: 'full',
        component: NewsCategoriesComponent,
      },
      {
        path: 'support',
        pathMatch: 'full',
        component: SupportComponent,
      },
    ],
  },

  {
    path: 'platform',
    component: PlatformComponent,
    children: [
      { path: '', redirectTo: 'product-information', pathMatch: 'full' },
      {
        path: 'product-information',
        component: ProductInformationComponent,
      },
      {
        path: 'technical-route',
        component: TechnicalRoutesComponent,
      },
      { path: 'mrl-database', component: MrlComponent },
      { path: 'gapd-database', component: GapdComponent },
      { path: 'gapd-database/detail', component: DetailComponent },
      { path: 'important-patent-database', component: ImpPatentComponent },
      { path: 'impurity-database', component: ImpuritiesComponent },
      { path: 'cipac-database', component: CipacComponent },
      { path: 'non-patent-database', component: NonPatentLandscapeComponent },
      { path: 'litigation-database', component: LitigationComponent },
      { path: 'scientific-docs-database', component: ScientificDocsComponent },
      { path: 'spc-database', component:SpcComponent },
      { path: 'quik-patent-database', component:QuikPatentComponent },
      { path: 'ipd-database', component:IpdComponent },

      //   {
      //     path: 'ximoneDB',

      //     component: XimOneMainComponent,
      //   },
      //   {
      //     path: 'discoveryDB',

      //     component: DiscoverysuiteMainComponent,
      //   },
      //   {
      //     path: 'customEmail',

      //     component: CustomemailMainComponent,
      //   },
    ],
  },
];
